var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money-11",
    transform: "translate(0 -2)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M15,2H1A.945.945,0,0,0,0,3V13a.945.945,0,0,0,1,1H15a.945.945,0,0,0,1-1V3A.945.945,0,0,0,15,2ZM11.1,12H4.9A4.23,4.23,0,0,0,2,9.1V6.9A4.23,4.23,0,0,0,4.9,4h6.3a4.23,4.23,0,0,0,2.9,2.9V9.2A3.9,3.9,0,0,0,11.1,12Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon9);
export default __webpack_public_path__ + "static/media/icon-9.a3cb1d14dcf2aa961de52e884a28c00f.svg";
export { ForwardRef as ReactComponent };